export class RegexPattern {
  emailRegex = "^(?!.*(?:''|\\.\\.|__|--|\\.@|-_|_-))[\\w.'-]+@([\\da-zA-Z-]+\\.)+[\\da-zA-Z-]{2,4}$";
  nameRegex = "^[a-zA-Z]+[^\\s]+[a-zA-Z]";
  zipRegex = "^(\\(?\\+?[0-9]*\\)?)?[0-9_\\- \\(\\)]*$";
}



// WEBPACK FOOTER //
// ./src/app/shared/models/regex.pattern.ts